import React from 'react';

const Tabs = ({ activeTab, setActiveTab }) => {
  return (
    <div className="tabs">
      <button 
        className={`tab-button ${activeTab === 'register' ? 'active' : ''}`}
        onClick={() => setActiveTab('register')}
      >
        Register Search
      </button>
      <button 
        className={`tab-button ${activeTab === 'instant' ? 'active' : ''}`}
        onClick={() => setActiveTab('instant')}
      >
        Instant Search
      </button>
      <button 
        className={`tab-button ${activeTab === 'view' ? 'active' : ''}`}
        onClick={() => setActiveTab('view')}
      >
        View Searches
      </button>
    </div>
  );
};

export default Tabs;
